export const ADD_TOKEN = 'ADD_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const RESET_TOKENS = 'RESET_TOKENS';
export const TOGGLE_LOOP = 'TOGGLE_LOOP';
export const SETUP_SECTION = 'SETUP_SECTION';
